import React, { useState } from 'react';
import { toast } from '../Toast';
import { Gift, Loader2, CheckCircle, Copy } from 'lucide-react';
import { authAxios } from '../../services/crmApi';

interface Props {
  applicationId: number;
  clientEmail?: string;
  clientName?: string;
}

export function PupCouponButton({ applicationId, clientEmail, clientName }: Props) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [copied, setCopied] = useState(false);

  const handleGenerate = async () => {
    if (!clientEmail) { toast.error('Brak emaila klienta'); return; }
    setLoading(true);
    try {
      const res = await authAxios.post('/api/kursy/admin/coupons/pup-grant', {
        application_ids: [applicationId],
        valid_days: 90,
      });
      if (res.data.coupons?.length > 0) {
        setResult(res.data.coupons[0]);
      } else {
        toast.error(res.data.failed?.[0]?.error || 'Nie udało sie wygenerowac kuponu');
      }
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Błąd serwera');
    } finally {
      setLoading(false);
    }
  };

  const copyInfo = () => {
    if (!result) return;
    const text = [
      `Platforma: ${result.platform}`,
      `Login: ${result.client_email}`,
      result.temp_password ? `Haslo: ${result.temp_password}` : '(Konto juz istnieje)',
      `Kod: ${result.coupon_code}`,
      `Link: ${result.platform_url}`,
      `Wazny do: ${result.valid_until ? new Date(result.valid_until).toLocaleDateString('pl-PL') : 'bezterminowo'}`,
    ].join('\n');
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (result) {
    return (
      <div className="w-full bg-green-50 border border-green-200 rounded-lg p-3 text-sm space-y-1.5">
        <div className="flex items-center gap-2 text-green-700 font-medium">
          <CheckCircle size={16} /> Kupon wygenerowany
        </div>
        <p className="text-gray-700"><strong>Platforma:</strong> {result.platform}</p>
        <p className="text-gray-700"><strong>Kod:</strong> <code className="bg-green-100 px-1.5 py-0.5 rounded font-mono text-green-800">{result.coupon_code}</code></p>
        <p className="text-gray-700"><strong>Login:</strong> {result.client_email}</p>
        {result.temp_password && (
          <p className="text-gray-700"><strong>Haslo:</strong> <code className="bg-yellow-100 px-1.5 py-0.5 rounded font-mono">{result.temp_password}</code></p>
        )}
        <p className="text-gray-500 text-xs">Wazny do: {result.valid_until ? new Date(result.valid_until).toLocaleDateString('pl-PL') : 'bezterminowo'}</p>
        <button onClick={copyInfo} className="w-full mt-1 py-1.5 bg-white border border-green-300 rounded-lg text-green-700 text-xs font-medium hover:bg-green-50 flex items-center justify-center gap-1.5">
          <Copy size={14} /> {copied ? 'Skopiowano!' : 'Kopiuj dane logowania'}
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={handleGenerate}
      disabled={loading || !clientEmail}
      className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-3 rounded-lg font-medium hover:from-green-700 hover:to-emerald-700 disabled:from-gray-400 disabled:to-gray-500 flex items-center justify-center shadow-lg"
    >
      {loading ? <Loader2 className="mr-2 animate-spin" size={20} /> : <Gift className="mr-2" size={20} />}
      {loading ? 'Generowanie...' : 'Kupon kursówy PUP'}
    </button>
  );
}
